const GALLERY_IMAGES = [
  {
    src: "https://customer-assets.emergentagent.com/job_gower-golf-portal/artifacts/1e3ttprv_ChatGPT%20Image%20May%2030%2C%202026%2C%2009_29_38%20AM.png",
    alt: "Sun setting through the trees on a Gower Golf Club green at golden hour",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_gower-golf-portal/artifacts/52cr0i65_ChatGPT%20Image%20May%2029%2C%202026%2C%2010_27_03%20PM.png",
    alt: "Lush fairway and yellow-flag green under clear blue sky at The Gower Golf Club",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_gower-golf-portal/artifacts/qc30yuux_ChatGPT%20Image%20May%2029%2C%202026%2C%2010_23_54%20PM.png",
    alt: "Sunset panorama over the Gower Peninsula with hills, lake and putting green",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_gower-golf-portal/artifacts/tqnw4gma_ChatGPT%20Image%20May%2029%2C%202026%2C%2010_22_47%20PM.png",
    alt: "Yellow-flag green beside a tranquil pond surrounded by mature trees",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_gower-golf-portal/artifacts/fbh8gn26_ChatGPT%20Image%20May%2029%2C%202026%2C%2010_21_05%20PM.png",
    alt: "Red-flag putting green looking out across rolling Gower fairways",
  },
];

export default function Gallery() {
  // Duplicate the array for seamless infinite loop
  const loop = [...GALLERY_IMAGES, ...GALLERY_IMAGES];

  return (
    <section
      data-testid="gallery-section"
      aria-label="The Gower Golf Club photo gallery"
      className="bg-white py-16 md:py-24 lg:py-28"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-10 md:mb-14 text-center">
        <span className="section-eyebrow">A Glimpse of the Club</span>
        <h2 className="font-serif-luxury text-3xl md:text-4xl lg:text-5xl text-[#0F4C3A] mt-4 leading-tight tracking-tight">
          Moments across
          <span className="italic text-gold-metallic"> the Gower fairways.</span>
        </h2>
      </div>

      <div
        className="gallery-wrap relative w-full overflow-hidden"
        data-testid="gallery-marquee"
      >
        {/* Edge fades */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-16 md:w-32 z-10 bg-gradient-to-r from-white to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-16 md:w-32 z-10 bg-gradient-to-l from-white to-transparent" />

        <div className="gallery-track flex gap-6 md:gap-8 py-2">
          {loop.map((img, i) => (
            <figure
              key={`${img.src}-${i}`}
              data-testid={`gallery-item-${i}`}
              className="relative shrink-0 w-[260px] sm:w-[320px] md:w-[420px] lg:w-[480px] h-[200px] sm:h-[240px] md:h-[300px] lg:h-[340px] rounded-2xl overflow-hidden shadow-[0_18px_44px_rgba(15,76,58,0.18)] border border-[#CBA153]/25 bg-white"
              aria-hidden={i >= GALLERY_IMAGES.length ? "true" : undefined}
            >
              <img
                src={img.src}
                alt={img.alt}
                loading="lazy"
                className="w-full h-full object-cover"
              />
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
